/**
 * Shared "assign to" user picker.
 *
 * The `UserOption` type, the `userLabel` rule and the `useUserOptions` loader
 * live in `utils/userOptions` — this file exports only the component, so React
 * Fast Refresh can hot-reload it without dropping page state.
 */
import { UserOption, userLabel } from '../utils/userOptions'

interface UserSelectProps {
  users: UserOption[]
  value: number | null
  onChange: (userId: number | null) => void
  /** Text for the empty option — "Unassigned" on a form, "All assignees" on a filter. */
  emptyLabel?: string
  disabled?: boolean
  className?: string
  ariaLabel?: string
}

const BASE_CLASS =
  'w-full border border-gray-300 rounded-md px-3 py-2 text-sm ' +
  'focus:outline-none focus:ring-1 focus:ring-primary-500 disabled:opacity-50'

export default function UserSelect({
  users,
  value,
  onChange,
  emptyLabel = 'Unassigned',
  disabled,
  className,
  ariaLabel,
}: UserSelectProps) {
  return (
    <select
      value={value === null || value === undefined ? '' : String(value)}
      onChange={(e) => onChange(e.target.value ? parseInt(e.target.value, 10) : null)}
      disabled={disabled}
      aria-label={ariaLabel}
      className={className ?? BASE_CLASS}
    >
      <option value="">{emptyLabel}</option>
      {users.map((u) => (
        <option key={u.id} value={String(u.id)}>{userLabel(u)}</option>
      ))}
    </select>
  )
}
